import React from 'react';
import { ReactSVG } from 'react-svg';
import { PublicComponentProps } from './types';

export const SVG404 = (props: PublicComponentProps) => (
  <ReactSVG {...props} src="https://static.ux.cimpress.io/assets/images/page_error_404.svg" />
);
